import { RawHTML } from '@wordpress/element';
import { __, sprintf } from '@wordpress/i18n';
import { TicketStatusLog } from '../type/Ticket';
import { dateI18n, getSettings } from '@wordpress/date';

function OpenLogItem( { log }: { log: TicketStatusLog } ) {
    const name = log?.changed_by_name
        ? log?.changed_by_name
        : __( 'No Name', 'dokan' );
    return (
        <div className="p-4 border-b border-[#EEEEEE] flex flex-col gap-4">
            <RawHTML>
                { /* eslint-disable-next-line @wordpress/valid-sprintf */ }
                { sprintf(
                    // eslint-disable-next-line @wordpress/i18n-translator-comments
                    __(
                        '%1s (%2s) %3sre-opened%4s this conversation on %5s',
                        'dokan'
                    ),
                    name,
                    log?.changed_by_email,
                    '<b>',
                    '</b>',
                    sprintf(
                        // translators: %1$s: withdraw date, %2$s: withdraw time
                        __( '%1$s at %2$s', 'dokan' ),
                        dateI18n(
                            getSettings().formats.date,
                            log?.date_created,
                            getSettings().timezone.string
                        ),
                        dateI18n(
                            getSettings().formats.time,
                            log?.date_created,
                            getSettings().timezone.string
                        )
                    )
                ) }
            </RawHTML>
        </div>
    );
}

export default OpenLogItem;
